import {Button, ButtonProps, useNotify, useRecordContext} from "react-admin";
import PublishIcon from "@material-ui/icons/Print";
import {clientNoJson} from "../../dataProvider";
import {url as URL} from "../../constants";
import {getFileNameFromContentDisposition} from "../../shared/utils";

export const PrintDocumentsButton = (props: ButtonProps & { format?: string }) => {
  const record = useRecordContext();
  const notify = useNotify();

  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    let res = null;

    try {
      let data: any = { ids: [record.id] }
      if (props.format) {
        data.format = props.format;
      }
      res = await clientNoJson(`${URL}/print_with_label/`, {
        method: "POST",
        data: data,
        responseType: "arraybuffer",
      });
    } catch (err: any) {
      const decoder = new TextDecoder("utf-8");
      const text = decoder.decode(err.response.data);

      // 2. Parse JSON
      try {
        const json = JSON.parse(text);
        console.log("Errore con JSON:", json);
        notify("La delivery " + json.delivery + " non contiene bolle", "error");
      } catch (e) {
        notify("ra.message.error", "error");
      }

      return;
    }
    const data = res.data; // or res.blob() if using blob responses

    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: res.headers["content-type"],
      })
    );
    const actualFileName = getFileNameFromContentDisposition(
      res.headers["content-disposition"]
    );

    // uses the download attribute on a temporary anchor to trigger the browser
    // download behavior. if you need wider compatibility, you can replace this
    // part with a library such as filesaver.js
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", actualFileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) link.parentNode.removeChild(link);
  };

  return (
    <Button {...props} label="" onClick={handleSubmit}>
      <><PublishIcon /> {props.format ? `${props.format.toUpperCase()}` : ""}</>
    </Button>
  );
};
